import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import ECG from '../icons/vitals/ECG.png'
import resp from '../icons/vitals/resp.png'
import temp from '../icons/vitals/temp.png'
import moment from 'moment-timezone'
import { DEFAULT_TIMEZONE } from '../constants'

const styles = {
  root: {
    padding: '45px 0',
  },
  flex: {
    display: 'flex'
  },
  header: {
    display: 'flex',
    marginBottom: 30
  },
  title: {
    fontSize: '1.5rem'
  },
  lastUpdated: {
    color: 'silver',
    paddingLeft: 10,
    display: 'flex',
    alignItems: 'center'
  },
  vitalWrapper: {
    width: 100,
    margin: 8,
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  vitalName: {
    textAlign: 'center',
  },
  vitalValue: {
    fontSize: '2.7rem',
    textAlign: 'center',
  },
  image: {
    display: 'block',
    width: 70,
    height: 70
  }
}

class VitalSigns extends Component {
  roundToSingleDecimalPlace (value) {
    if (!value) return '...'
    return Math.round(value * 10) / 10
  }

  renderVitalSign (vitalName, link, img, vitalValue, roundingFunction = Math.round) {
    const { classes, onClick } = this.props
    return (
      <div className={classes.vitalWrapper} onClick={e => onClick(link)}>
        <img className={classes.image} src={img} alt={vitalName} />
        <Typography className={classes.vitalName}>{ vitalName }</Typography>
        <Typography className={classes.vitalValue}>{ vitalValue ? roundingFunction(vitalValue) : '...' }</Typography>
      </div>
    )
  }

  renderTemperature () {
    const { temperature, temperature_url } = this.props.vitals
    return this.renderVitalSign('body temperature', temperature_url, temp, temperature, this.roundToSingleDecimalPlace)
  }

  renderECGHeartRate () {
    const { ecg, ecg_url } = this.props.vitals
    return this.renderVitalSign('ECG Heartrate', ecg_url, ECG, ecg, )
  }

  renderRespiratoryHeartRate () {
    const { respiratory, respiratory_url } = this.props.vitals
    return this.renderVitalSign('respiratory heartrate', respiratory_url, resp, respiratory)
  }

  render () {
    const { classes, lastUpdated } = this.props
    return (
      <div className={classes.root}>
        <div className={classes.header}>
          <Typography className={classes.title}>Vital Signs</Typography>
          { lastUpdated && <Typography className={classes.lastUpdated}>{moment.utc(lastUpdated).tz(DEFAULT_TIMEZONE).format('MMMM DD YYYY hh:mm A')}</Typography> }
        </div>
        <div className={classes.flex}>
          {this.renderTemperature()}
          {this.renderECGHeartRate()}
          {this.renderRespiratoryHeartRate()}
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(VitalSigns)



// WEBPACK FOOTER //
// ./src/components/VitalSigns.js